/**
 * Contacto fuera de la plataforma detectado en texto libre de un anuncio.
 *
 * El chat ya se redacta server-side (WS-C · C5) y los correos al anfitrión no
 * llevan contacto (C3), pero el título, la descripción y las reglas de un
 * vehículo son texto libre que se publica tal cual. Encontrado EN VIVO durante
 * el barrido UX: un anuncio real publicaba "ORDÉNALA AL 7259-3144 O AL
 * 7590-1426" — reservar por fuera de Tago es exactamente lo que la estrategia
 * de anti-desintermediación prohíbe.
 *
 * La guarda hace explícito el contrato al momento de escribir (el servidor
 * sigue siendo la autoridad para el resto del aislamiento). Pura a propósito:
 * un test la fija palabra por palabra.
 */

/**
 * Teléfonos salvadoreños en sus tres formas reales: con código de país
 * separado, 4-4 (la que usa la gente de memoria) y 8 dígitos corridos.
 * El lookahead evita el falso positivo obvio del rango de años: "2010-2018"
 * no es un teléfono.
 */
const PHONE_PATTERNS: readonly RegExp[] = [
  /\+?503[\s-]?\d{4}[\s-]?\d{4}/,
  /\b(?!(?:19|20)\d{2}[-\s](?:19|20)\d{2}\b)\d{4}[-\s]\d{4}\b/,
  /\b\d{8}\b/,
]

/** Correos: la coordinación va por el chat, no por mail. */
const EMAIL_PATTERN = /[\w.+-]+@[\w-]+\.[A-Za-z]{2,}/

/** Apps de mensajería o redes: aunque no lleven número, son el mismo pedido. */
const MESSAGING_PATTERN =
  /\b(whats\s*app|wsp|telegram|instagram|facebook|tiktok|onlyfans|signal)\b/i

export function detectOffPlatformContact(text: string | null | undefined): boolean {
  if (!text) return false
  return [...PHONE_PATTERNS, EMAIL_PATTERN, MESSAGING_PATTERN].some((pattern) => pattern.test(text))
}
